import styled from 'styled-components';

import { IStyledSwitcherBox } from './index';

export const StyledSwitcherBox = styled.div<IStyledSwitcherBox>`
    position: relative;
    width: 100%;
    display: flex;
    max-width: 133px;
    background-color: ${({ theme }) => theme['surface-secondary']};
    border-radius: 8px;
    border: none;
    padding: 2px;
    justify-content: space-between;
    margin: 0 auto ${({ mb }) => mb && `${mb}px`};
`;

export const StyledSwitcherLabel = styled.label<IStyledSwitcherBox>`
    position: relative;
    width: 100%;
    height: 24px;
    cursor: pointer;
    white-space: nowrap;
`;

export const StyledText = styled.p<IStyledSwitcherBox>`
    position: absolute;
    top: 50%;
    left: 50%;
    height: 14px;
    transform: translate(-50%, -50%);
    color: ${({ theme }) => theme['text-main']};
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
`;

export const StyledSwitcherInput = styled.input<IStyledSwitcherBox>`
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 8px;
    border-radius: 6px;

    &:checked {
        background-color: ${({ theme }) => theme['primary-default']};
    }
    &:checked + ${StyledText} {
        color: ${({ theme }) => (theme['on-primary'])};
    }
`;
